import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ReactGA from 'react-ga4';
import axios from 'config/axios';
import { auth, createUserWithEmailAndPassword } from 'config/firebase';
import SignUpVector from 'assets/vectors/SignUp.svg';
import CountryCodes from 'assets/json/countries.json';
import Helmet from 'components/Helmet';
import TextInput from 'components/TextInput';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import SignInWithGoogle from 'components/SignInWithGoogle';
import { useAppDispatch } from 'hooks/useStore';
import { signIn } from 'store/user';
import { setAlert, setError } from 'store/error';
import './index.css';

function SignUp() {
    const defaultCountry = CountryCodes.find(country => country.isoCode === 'US');
    
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [country, setCountry] = useState(
        <div className='signUp__country' id={defaultCountry.isoCode}>
            <img src={defaultCountry.flag} />
            &nbsp;&nbsp;
            <p>{defaultCountry.name}</p>
        </div>
    );
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');

    const dispatch = useAppDispatch();

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (password !== confirm) {
            // console.log('The passwords don\'t match!');
            dispatch(setAlert({
                response: {
                    data: {
                        message: 'The passwords don\'t match!'
                    }
                }
            }));
        }
        else if (!country) {
            dispatch(setAlert({
                response: {
                    data: {
                        message: 'Please fill in all the required fields.'
                    }
                }
            }));
        }
        else {
            createUserWithEmailAndPassword(auth, email, password)
                .then(userCredential => {
                    // console.log(userCredential.user);

                    axios.post('students/sign-up/', {
                            firstName: firstName,
                            lastName: lastName,
                            countryCode: country?.props.id,
                            phoneNumber: null,
                            gender: null,
                            birthDate: null,
                            parentInfo: null,
                            highSchool: null,
                            classOf: null,
                            postalCode: null
                        })
                        .then(res => {
                            dispatch(signIn(res.data?.user));

                            ReactGA.event('sign_up');
                        })
                        .catch(error => {
                            userCredential.user.delete();

                            dispatch(setError(error));
                        });
                })
                .catch(error => {
                    dispatch(setAlert({
                        response: {
                            data: {
                                message: error.message
                            }
                        }
                    }));
                });
        }
    }

    return (
        <div className='layout'>
            <Helmet
                title='Create an Account - The SAT Crash Course'
                description='Create an account to get access to a free SAT practice test and to purchase courses of The SAT Crash Course and new digital SAT practice tests.'
            />
            <form className='signUp' onSubmit={handleSubmit}>
                <img
                    className='signUp__vector'
                    src={SignUpVector}
                    alt='Sign Up'
                />
                <h1 className='signUp__header'>
                    Create your account
                </h1>
                <div className='signUp__formGrid'>
                    <TextInput
                        className='signUp__formGridItem'
                        name='firstName'
                        label='First Name'
                        onChange={(event) => setFirstName(event.target.value)}
                        required
                        type='text'
                        value={firstName}
                    />
                    <TextInput
                        className='signUp__formGridItem'
                        name='lastName'
                        label='Last Name'
                        onChange={(event) => setLastName(event.target.value)}
                        required
                        type='text'
                        value={lastName}
                    />
                </div>
                <Dropdown
                    data={CountryCodes.map(country => (
                        <div className='signUp__country' id={country.isoCode}>
                            <img src={country.flag} />
                            &nbsp;&nbsp;
                            <p>{country.name}</p>
                        </div>
                    ))}
                    onSelect={(value) => setCountry(value)}
                    label='Country'
                    required
                    value={country}
                />
                <TextInput
                    name='email'
                    label='email address'
                    onChange={(event) => setEmail(event.target.value)}
                    required
                    type='email'
                    value={email}
                />
                <TextInput
                    name='password'
                    label='password'
                    onChange={(event) => setPassword(event.target.value)}
                    required
                    type='password'
                    value={password}
                />
                <TextInput
                    name='confirm'
                    label='confirm password'
                    onChange={(event) => setConfirm(event.target.value)}
                    required
                    type='password'
                    value={confirm}
                />
                <Button
                    className='signUp__button'
                    // disabled={!email || !password || !confirm}
                    fullWidth
                    secondary={!email || !password || !confirm}
                    type='submit'
                >
                    CREATE ACCOUNT
                </Button>
                <SignInWithGoogle />
                <div className='signUp__action'>
                    <p className='signUp__actionText'>
                        Already have an account?
                    </p>
                    <Link to='/sign-in' className='signUp__actionLink'>
                        Sign in here
                    </Link>
                </div>
            </form>
        </div>
    );
}

export default SignUp;